export const FIELDS = {

  ID: 'id',
  SERVICE_ORDER_LINE_ITEM_ID: 'serviceOrderLineItemId',
  SERVICE_ORDER_ID: 'serviceOrderId',
  SERVICE_ORDER_LINE_ID: 'serviceOrderLineId',
  SALES_ORDER_ID: 'salesOrderId',
  SALES_ORDER_LINE_ID: 'salesOrderLineId',
  STATUS_ID: 'statusId',
  STATUS_NAME: 'statusName',
  COMPANY_ID: 'companyId',
  COMPANY_NAME: 'companyName',
  INVENTORY_ID: 'inventoryId',
  QUANTITY: 'quantity',
  TOTAL: 'total',
  PART_ID: 'partId',
  PART_NUMBER: 'partNumber',
  VENDOR_PN: 'vendorPn',
  ALT_NUMBER: 'altNumber',
  INTERNAL_PN: 'internalPn',
  NSNNUMBER: 'nsnNumber',
  HARMONIZED_CODE: 'harmonizedCode',
  SKU: 'sku',
  DESCRIPTION: 'description',
  MANUFACTURER_ID: 'manufacturerId',
  MFG_NAME: 'mfgName',
  INVENTORY_CLASS_ID: 'inventoryClassId',
  CLASS_NAME: 'className',
  INVENTORY_CATEGORY_ID: 'inventoryCategoryId',
  CATEGORY_NAME: 'categoryName',
  PACKAGE_ID: 'packageId',
  PACKAGE: 'package',
  PIECE_PER_PKG: 'piecePerPkg',
  PHYS_PKG: 'physPkg',
  LEAD_FREE: 'leadFree',
  TEMP_RATING: 'tempRating',
  UO_MID: 'uoMId',
  UOM: 'uom',
  DATE_CODE: 'dateCode',
  LOT_CODE: 'lotCode',
  REVISION: 'revision',
  CONDITION_ID: 'conditionId',
  CONDITION_NAME: 'conditionName',
  COUNTRY_OF_ORIGIN_ID: 'countryOfOriginId',
  COUNTRY_OF_ORIGIN_NAME: 'countryOfOriginName',
  SERVICE_ITEM_TYPE_ID: 'serviceItemTypeId',
  SERVICE_TYPE_NAME: 'serviceTypeName',
  SERVICE_ORDER_LINE_ITEM_QUANTITY: 'serviceOrderLineItemQuantity',
  SERVICE_ORDER_LINE_ITEM_COST: 'serviceOrderLineItemCost',
  SERVICE_ORDER_LINE_ITEM_TOTAL: 'serviceOrderLineItemTotal',
  COMMENTS: 'comments',
  POLINE_COMMENTS: 'poLineComments',
  POLINE_QUANTITY: 'poLineQuantity',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  PURCHASE_ORDER_LINE_ID: 'purchaseOrderLineId',
  CREATED_BY_USER_ID: 'createdByUserId',
};
